import { Link, useLocation, useNavigate } from "react-router-dom";
import { Landmark, LogOut } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";
import { Navbar } from "@/components/Navbar";
import { GateBadge, DisclosureBar } from "./api";
import { Copilot } from "@/components/Copilot";

const NAV = [
  { label: "Dashboard", path: "/investors/portal" },
  { label: "Calculator", path: "/investors/portal/calculator" },
  { label: "Documents", path: "/investors/portal/documents" },
  { label: "Statements", path: "/investors/portal/statements" },
];

export default function InvestorShell({ children, gates, title, subtitle }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div className="min-h-screen bg-ink" data-testid="investor-shell">
      <Navbar />
      <div className="border-b border-black/[0.08] bg-white/80 pt-[92px] backdrop-blur">
        <div className="container-x flex flex-wrap items-center justify-between gap-3 py-4">
          <div>
            <p className="eyebrow flex items-center gap-2 !text-red-700"><Landmark size={14} /> Investor Portal</p>
            <h1 className="font-display text-xl font-extrabold tracking-tight text-offwhite" data-testid="investor-page-title">{title}</h1>
            {subtitle && <p className="mt-1 text-xs text-muted">{subtitle}</p>}
          </div>
          <div className="flex items-center gap-2">
            {gates && <GateBadge label="Legal Gate" value={gates.legal_launch_gate} testid="gate-legal" />}
            {gates && <GateBadge label="Payments" value={gates.payments_gate} testid="gate-payments" />}
            <span className="hidden text-xs text-muted sm:block">{user?.email}</span>
            <button onClick={async () => { await logout(); navigate("/investors"); }} className="btn-ghost !px-4 !py-2 !text-xs" data-testid="investor-signout-btn">
              <LogOut size={13} /> Sign out
            </button>
          </div>
        </div>
        <nav className="container-x flex gap-1 overflow-x-auto" aria-label="Investor">
          {NAV.map((n) => (
            <Link key={n.path} to={n.path} data-testid={`investor-nav-${n.label.toLowerCase()}`}
              className={`whitespace-nowrap border-b-2 px-4 py-3 text-sm font-semibold transition-colors ${location.pathname === n.path ? "border-red-700 text-offwhite" : "border-transparent text-muted hover:text-offwhite"}`}>
              {n.label}
            </Link>
          ))}
        </nav>
      </div>
      <main className="container-x py-8 pb-24">
        <div className="mb-6"><DisclosureBar /></div>
        {children}
      </main>
      <Copilot audience="investor" />
    </div>
  );
}
